import PropTypes from "prop-types";
import type { TrackStateMode } from '@/types';

export const trackPropTypes = {
   state: PropTypes.oneOf<TrackStateMode>(['status', 'difficulty']),
   isOpen: PropTypes.bool
};

export const mapHeight: number = 1648;
export const mapWidth: number = 2865;

export const tracksWidth: number = 2;
export const arrowWidth: number = 2;
